



















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Header extends Vue {
  private get activeIndex() {
    if (this.windowScrollY > this.windowHeight) {
      switch (true) {
        case this.windowScrollY > 1600 && this.windowScrollY <= 3700:
          return '2';
        case this.windowScrollY > 3700:
          return '3';
        default:
          return '1';
      }
    }
  }
}
